import { C } from "./theme";

export const G = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=JetBrains+Mono:wght@400;500&display=swap');
:root{--pri:${C.pri};--bg:${C.bg};--tx:${C.tx}}
*{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth;font-size:16px}
body{font-family:'DM Sans',sans-serif;background:var(--bg);color:var(--tx);overflow-x:hidden}
::-webkit-scrollbar{width:5px}::-webkit-scrollbar-thumb{background:${C.bd};border-radius:3px}
::placeholder{color:${C.txD}}
@keyframes fu{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
@keyframes fi{from{opacity:0}to{opacity:1}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes pulse{0%,100%{opacity:.3}50%{opacity:1}}
@keyframes drawSig{0%{stroke-dashoffset:200}40%{stroke-dashoffset:0}100%{stroke-dashoffset:0}}
@keyframes scan{0%{top:8%}50%{top:80%}100%{top:8%}}
@keyframes stampFade{0%{opacity:.6}30%{opacity:.1}50%{opacity:0}80%{opacity:0}100%{opacity:.6}}
@keyframes scoreCount{0%{opacity:0;transform:scale(.7)}30%{opacity:1;transform:scale(1)}100%{opacity:1;transform:scale(1)}}
@keyframes batchPulse{0%{width:0%}50%{width:78%}100%{width:0%}}
.afu{animation:fu .65s ease both}.afi{animation:fi .5s ease both}
.ad1{animation-delay:.1s}.ad2{animation-delay:.2s}.ad3{animation-delay:.3s}.ad4{animation-delay:.4s}.ad5{animation-delay:.5s}
input:focus,select:focus{outline:none;border-color:var(--pri)!important;box-shadow:0 0 0 3px rgba(53,104,168,.15)!important}
button{font-family:'DM Sans',sans-serif;cursor:pointer}
a{text-decoration:none}
.container{max-width:1200px;margin:0 auto;padding:0 24px}
@media(max-width:860px){
  .hide-m{display:none!important}
  .show-m{display:flex!important}
  .g1-m{grid-template-columns:1fr!important}
  .g2-m{grid-template-columns:1fr 1fr!important}
  .hero-g{grid-template-columns:1fr!important;text-align:center}
  .hero-g .hero-cta{justify-content:center}
  .hero-g .hero-stats{justify-content:center}
  .feat-g{grid-template-columns:1fr 1fr!important}
  .step-g{grid-template-columns:1fr 1fr!important}
  .deploy-g{grid-template-columns:1fr!important}
  .foot-g{grid-template-columns:1fr 1fr!important}
  .sidebar-d{display:none!important}
  .topbar-quick{display:none!important}
  .dash-main{padding:16px!important}
}
@media(max-width:520px){
  .feat-g{grid-template-columns:1fr!important}
  .g2-m{grid-template-columns:1fr!important}
  .foot-g{grid-template-columns:1fr!important}
  .stat-g{grid-template-columns:1fr 1fr!important}
}
`;
